"use client";

import { useActionState } from "react";
import { useSearchParams } from "next/navigation";
import { Car, LogIn } from "lucide-react";
import { loginAction } from "./actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Suspense } from "react";

function LoginForm() {
  const searchParams = useSearchParams();
  const from = searchParams.get("from") ?? "";

  const [state, action, pending] = useActionState(loginAction, undefined);

  return (
    <form action={action} className="space-y-4">
      <input type="hidden" name="from" value={from} />

      <div>
        <label className="text-sm font-medium text-gray-700 block mb-1">
          E-mail
        </label>
        <Input
          type="email"
          name="email"
          placeholder="admin@naleasing.cz"
          autoComplete="email"
          required
          className="h-10"
        />
      </div>

      <div>
        <label className="text-sm font-medium text-gray-700 block mb-1">
          Heslo
        </label>
        <Input
          type="password"
          name="password"
          placeholder="••••••••"
          autoComplete="current-password"
          required
          className="h-10"
        />
      </div>

      {state?.error && (
        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
          {state.error}
        </p>
      )}

      <Button
        type="submit"
        disabled={pending}
        className="w-full bg-[#1a6ef5] hover:bg-[#155dd4] text-white h-10 gap-2"
      >
        <LogIn className="h-4 w-4" />
        {pending ? "Přihlašování..." : "Přihlásit se"}
      </Button>
    </form>
  );
}

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="h-10 w-10 rounded-xl bg-[#1a6ef5] flex items-center justify-center">
              <Car className="h-5 w-5 text-white" />
            </div>
            <span className="text-xl font-bold text-gray-900">
              NaLeasing<span className="text-gray-400 font-normal">.cz</span>
            </span>
          </div>
          <p className="text-sm text-gray-500">Přihlašte se do partnerského portálu</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
          <h1 className="text-lg font-bold text-gray-900 mb-5">Přihlášení</h1>
          <Suspense>
            <LoginForm />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
